__turbopack_context__.v({
  "footer": "U_RByW_footer",
  "formContainer": "U_RByW_formContainer",
  "groupOrderNameLabel": "U_RByW_groupOrderNameLabel",
  "groupSizeInput": "U_RByW_groupSizeInput",
  "groupSizeInputWrapper": "U_RByW_groupSizeInputWrapper",
});
